@use "../../styles/breakpoint.module.scss" as *;

.panel {
    --primary: var(--black);

    composes: safeGridContainer from "../../styles/composable/layout.module.css";

    --labui-grid-gap: var(--spacer-40);
}

.documents {
    grid-column: 2 / span 5;

    @media ($below-tablet) {
        grid-column: 1 / -1;
    }
}

.sidebar {
    grid-column: 7 / span 5;

    @media ($below-tablet) {
        grid-column: 1 / -1;
    }
}

.documentsFull,
.sidebarFull {
    grid-column: 3 / span 8;

    @media ($below-tablet) {
        grid-column: 1 / -1;
    }
}

.sidebarGroup {
    margin-bottom: var(--spacer-40);
}

.sidebarHeading {
    display: block;
    padding-bottom: var(--spacer-12);
    margin: 0;
    border-bottom: 1px solid var(--primary);
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.sidebarItems {
    list-style: none;
    padding: 0;
    margin: 0;
}

.sidebarItem {
    display: flex;
    align-items: center;
    gap: var(--spacer-8);
    padding-block: var(--spacer-12);
    border-bottom: 1px solid var(--gray-300);
    font: var(--font-p-16);
}

.sidebarItemLink {
    font: var(--font-text-link-12);
    text-decoration: underline;
}
